// Init Firestore
import _ from 'lodash';
import moment from 'moment';

var nps_helper = {


  getDailyNPS: function(nps_data) {

    let data = { x_axis: [], y_axis: [] };

    // Set X Axis to be the past 14 days; init Y axis
    for (let i = 0; i < 14; i++) {
      let year_month_day = moment().subtract(i, 'days').format('YYYY_MM_DD');
      data.x_axis.push(year_month_day);
      data.y_axis.push(0);
    };
    data.x_axis = data.x_axis.reverse();

    // Add together promoter, detractor and total counts across all surveys
    let daily_figures = {};

    _.forEach(getDailyNPSFigures(nps_data), (values, date) => {
      for (let key of ['promoter_count', 'detractor_count', 'total_count']) {
        if (!daily_figures[date]) {
          daily_figures[date] = {};
        };
        if (daily_figures[date][key]) {
          daily_figures[date][key] += values[key];
        } else {
          daily_figures[date][key] = values[key];
        };
      };
    });

    // Calculate NPS score for each day and add to the Y axis if it's from the last 14 days.
    _.forEach(daily_figures, (figures, date) => {
      let nps_score = ((figures.promoter_count || 0) / figures.total_count * 100) - ((figures.detractor_count || 0) / figures.total_count * 100);
      if (data.x_axis.includes(date)) {
        data.y_axis[data.x_axis.indexOf(date)] = Math.round(nps_score);
      };
    });

    // Change X axis to be more readable
    _.forEach(data.x_axis, (date, index) => {
      data.x_axis[index] = `${parseInt(date.substring(5,7))}/${date.substring(8,10)}`;
    });

    return data;

  },


  getMonthlyNPS: function(nps_data) {

    // Init the months of the year and y axis
    let data = {
      x_axis: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      y_axis: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    };

    // Add together promoter, detractor and total counts across all surveys
    let monthly_figures = {};
    _.forEach(getDailyNPSFigures(nps_data), (values, date) => {
      let month_int = date.substring(5, 7);
      for (let key of ['promoter_count', 'detractor_count', 'total_count']) {
        if (!monthly_figures[month_int]) {
          monthly_figures[month_int] = {};
        };
        if (monthly_figures[month_int][key]) {
          monthly_figures[month_int][key] += values[key];
        } else {
          monthly_figures[month_int][key] = values[key];
        };
      };
    });

    //console.log(monthly_figures);

    // Calculate NPS score for each month and add to the Y axis.
    _.forEach(monthly_figures, (figures, month_int) => {
      let nps_score = ((figures.promoter_count || 0) / figures.total_count * 100) - ((figures.detractor_count || 0) / figures.total_count * 100);
      data.y_axis[parseInt(month_int)-1] = Math.round(nps_score);
    });

    return data;

  },


  is_nps_survey(survey) {
    if (!survey || !survey.questions) {
      return false;
    };
    let is_nps = false;
    for (const question_index in survey.questions) {
      let question = survey.questions[question_index];
      if (question.answer_type === 'nps') {
        is_nps = true;
      };
    };
    return is_nps;
  },

};



function getDailyNPSFigures(nps_data) {
  let daily_nps_figures = {};
  _.forEach(nps_data, (scores_for_date, date) => {
    let total_count = 0;
    let detractor_count = 0;
    let promoter_count = 0;
    _.forEach(scores_for_date, (score_count, score) => {
      total_count += score_count;
      if (score <= 6) {
        detractor_count += score_count;
      };
      if (score >= 9) {
        promoter_count += score_count;
      };
    });
    if (!daily_nps_figures[date]) {
      daily_nps_figures[date] = { total_count, promoter_count, detractor_count };
    } else {
      daily_nps_figures[date].total_count += total_count;
      daily_nps_figures[date].promoter_count += promoter_count;
      daily_nps_figures[date].detractor_count += detractor_count;
    };
  });
  return daily_nps_figures;
};




export { nps_helper };
